import {
  RateStarsBlockWrapper,
  RateStarsWrapper,
  RateStarsLabel,
} from './ratestars.style';
import { FaStar, FaRegStar, FaStarHalfAlt } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';

const RateStars = ({
  value,
  size = '16px',
  valueMax = 5,
  readOnly = false,
  name = 'rating-star',
  label = null,
  ...props
}) => {
  const [rate, setRate] = useState(value);
  const [tmpRate, setTmpRate] = useState(value);

  const rateStarChanged = event => {
    const rating = event.target.value;
    setRate(rating);
    setTmpRate(0);
    props.changed(event);
  };

  useEffect(() => {
    setRate(value);
  });

  const buildStars = () => {
    let starsItem = [];
    for (let i = 1; i <= valueMax; i++) {
      let inputId = name + i;
      let icon = null;
      {
        (rate || tmpRate) && (rate >= i || tmpRate >= i)
          ? (icon = <FaStar size={size} />)
          : (rate || tmpRate) &&
            ((rate > i - 1 && rate < i) || (tmpRate > i - 1 && tmpRate < i))
          ? (icon = <FaStarHalfAlt size={size} />)
          : (icon = <FaRegStar size={size} />);
      }

      let wrapper = readOnly ? (
        <span children={icon} />
      ) : (
        <label
          children={icon}
          htmlFor={inputId}
          onMouseEnter={() => setTmpRate(i)}
          onMouseLeave={() => setTmpRate(rate)}
          style={{
            cursor: 'pointer',
          }}
        />
      );

      starsItem.push(
        <div key={i}>
          {wrapper}
          {!readOnly && (
            <input
              id={inputId}
              type="radio"
              value={i}
              name={name}
              onChange={rateStarChanged}
              style={{
                border: 0,
                clip: 'rect(0 0 0 0)',
                height: '1px',
                margin: '-1px',
                overflow: 'hidden',
                padding: 0,
                position: 'absolute',
                whiteSpace: 'nowrap',
                width: '1px',
              }}
            />
          )}
        </div>
      );
    }
    return starsItem;
  };

  return (
    <RateStarsBlockWrapper {...props}>
      {label && <RateStarsLabel>{label}</RateStarsLabel>}
      <RateStarsWrapper>{buildStars()}</RateStarsWrapper>
    </RateStarsBlockWrapper>
  );
};

export default RateStars;
